<template>
  <svg
    class="custom-icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 10C6.88071 10 8 11.1193 8 12.5V15.5C8 16.8807 6.88071 18 5.5 18H2.5C1.11929 18 0 16.8807 0 15.5V12.5C0 11.1193 1.11929 10 2.5 10H5.5Z"
    />
    <path
      d="M15.5 10C16.8807 10 18 11.1193 18 12.5V15.5C18 16.8807 16.8807 18 15.5 18H12.5C11.1193 18 10 16.8807 10 15.5V12.5C10 11.1193 11.1193 10 12.5 10H15.5Z"
    />
    <path
      d="M5.5 0C6.88071 0 8 1.11929 8 2.5V5.5C8 6.88071 6.88071 8 5.5 8H2.5C1.11929 8 0 6.88071 0 5.5V2.5C0 1.11929 1.11929 0 2.5 0H5.5Z"
    />
    <path
      d="M15.5 0C16.8807 0 18 1.11929 18 2.5V5.5C18 6.88071 16.8807 8 15.5 8H12.5C11.1193 8 10 6.88071 10 5.5V2.5C10 1.11929 11.1193 0 12.5 0H15.5Z"
    />
  </svg>
</template>
